import React, {useCallback, useEffect, useState} from "react";
import QTextBox from "../../../../common/components/QTextBox";
import { ResponseInterface } from "../../../../interfaces/ResponseInterface";
import { config } from "../../../../config";
import { Col, Row } from "reactstrap";
import { Formik } from "formik";
import QButton from "../../../../common/components/QButton";
import { useDispatch } from "react-redux";
import {setLoading, setToast} from "../../../../app/rootReducer";
import SetupApi from "../../../../common/api/functions/Setup";
import { SetupInterface } from "../../../../interfaces/private/SetupInterface";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import QSelect from "../../../../common/components/QSelect";
import { SelectOptionInterface } from "../../../../interfaces/SelectOptionInterface";
import {LayoutInterface, PaymentTermInterface, ProductInterface, VatZoneInterface} from "../../../../interfaces/economic/CommonInterface";
import QSelectSearch from "../../../../common/components/QSelectSearch";
import {debounce} from "lodash";

interface Props {
    model: SetupInterface,
    setOpen: Function,
    setLoadingFunc: Function,
    setSetup: Function,
    setup: SetupInterface,
    allDataSetup: any,
}
interface Layout{
    layoutNumber: number,
    name: string
}
const BodyInvoiceSetupComponent: React.FC<Props> = ({allDataSetup, model, setOpen, setLoadingFunc, setSetup,setup }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);

    const {
        layouts,
        paymentTerms,
        bookedWiths,
        otherRef,
        invoiceSources = {
            invoice: 'Stripe Invoice',
            checkout: 'Stripe Checkout',
        },
        vatZones = [],
    } = allDataSetup;
    useEffect(() => {
        if (loading) {
            load().then(async () => {setLoading(false)})
        }
    }, [loading])


    const promiseOptions = useCallback(debounce((e:string,callback) => {
        const controller = new AbortController();
        if(e.length > 1){
            SetupApi.searchProduct(e).then(async (response: ResponseInterface | any)=> {
                return response?.data?.data?.map((item: ProductInterface) => ({
                    label: item.productNumber + ' - ' + item.name,
                    value: item.productNumber,
                }))
            }).then(results => {
                callback(results);
            });
        }else{
            callback(null);
        }

        return () => controller.abort();
    },500),[]);

    const load = async () => {
        try {
            await SetupApi.detail().then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    setSetup(
                        response?.data?.data || {}
                    )
                }
            })

        } catch (err) {
        }
        if (loading) {
            await setLoading(false);
        }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={{
                    ...setup,
                    stripe_invoice_source: setup.stripe_invoice_source ?? 'invoice',
                }}
                onSubmit={(values: any) => {
                    SetupApi.update(values).then(async (response: ResponseInterface | any) => {
                        if (response.status === config.STATUS_CODE.OK) {
                            setSetup(
                                response?.data?.data || {}
                            )
                    /*        let objectParams = QHelpers.object.convertParamUrlToObject(window.location.search)
                            if (objectParams?.token) {
                                history.push(RouteDefine.economic)
                            }*/

                            await setOpen(false);
                            await setLoadingFunc(true);
                            await dispatch(setToast({
                                message: "Update success",
                                type: config.TOAST_TYPE.SUCCESS
                            }))
                        }
                    })
                }}
            >
                {formik => {
                    return (
                        <React.Fragment>
                            <Row>
                                <Col>
                                    <QSelect
                                        label={t("economic.invoiceSource")}
                                        value={formik.values.stripe_invoice_source}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('stripe_invoice_source',option.value);
                                        }}
                                        options={Object.entries(invoiceSources).map(([key, value]) => ({
                                            label: value,
                                            value: key,
                                        }))}
                                        error={formik.errors?.stripe_invoice_source}
                                    />
                                    <h6 className="mt-3">{t("economic.vatZones")}</h6>
                                    {[
                                        ['economic_invoice_vat_zone_domestic_number', 'economic.vatZoneDomestic'],
                                        ['economic_invoice_vat_zone_eu_number', 'economic.vatZoneEu'],
                                        ['economic_invoice_vat_zone_abroad_number', 'economic.vatZoneAbroad'],
                                        ['economic_invoice_vat_zone_domestic_without_vat_number', 'economic.vatZoneDomesticWithoutVat'],
                                    ].map(([field, label]) => (
                                        <QSelect
                                            key={field}
                                            label={t(label)}
                                            value={(formik.values as any)[field]}
                                            onChange={(option: SelectOptionInterface) => {
                                                formik.setFieldValue(field, option.value);
                                            }}
                                            options={vatZones.map((zone: VatZoneInterface) => ({
                                                label: zone.name,
                                                value: zone.vatZoneNumber,
                                            }))}
                                            error={(formik.errors as any)?.[field]}
                                        />
                                    ))}
                                    <QSelect
                                        label={'Layout'}
                                        value={parseInt(formik.values.economic_invoice_layout_number)}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_invoice_layout_number',option.value);
                                        }}
                                        options={layouts.map((a:LayoutInterface)=>({label:a.name,value:a.layoutNumber}))}
                                        error={formik.errors?.economic_invoice_layout_number}
                                    />
                                    <QSelect
                                        label={'Payment Term'}
                                        value={parseInt(formik.values.economic_invoice_payment_terms_number)}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_invoice_payment_terms_number',option.value);
                                        }}
                                        options={paymentTerms.map((a:PaymentTermInterface)=>({label:a.name,value:a.paymentTermsNumber}))}
                                        error={formik.errors?.economic_invoice_payment_terms_number}
                                    />

                                    <QSelect
                                        label={'Booked with'}
                                        value={formik.values.economic_invoice_booked_with}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_invoice_booked_with',option.value);
                                        }}
                                        options={Object.entries(bookedWiths).map(([key, value]) => ({label:value,value:key}))}
                                        error={formik.errors?.economic_invoice_booked_with}
                                    />

                                    <QSelect
                                        label={'Other reference'}
                                        value={formik.values.economic_invoice_other_ref}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_invoice_other_ref',option.value);
                                        }}
                                        options={Object.entries(otherRef).map(([key, value]) => ({label:value,value:key}))}
                                        error={formik.errors?.economic_invoice_other_ref}
                                    />
                                    {/*<QTextBox
                                        label={'Product discount'}
                                        value={formik.values.economic_invoice_product_discount_number}
                                        placeholder={'Fill in product number using for discount'}
                                        onChange={(event: any) => {
                                            formik.setFieldValue('economic_invoice_product_discount_number', event);
                                        }}
                                        error={formik.errors?.economic_invoice_product_discount_number}

                                    />*/}

                                    <QSelectSearch
                                        label={'Product discount'}
                                        value={formik.values.economic_invoice_product_discount_number}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_invoice_product_discount_number',option.value);
                                        }}
                                        // loading={loadingProduct}
                                        // options={products.map((a:ProductInterface)=>({label:a.productNumber + ' - ' + a.name,value:a.productNumber}))}
                                        error={formik.errors?.economic_invoice_product_discount_number}
                                        placeholder={'Fill in product number using for discount'}
                                        promiseOptions={promiseOptions}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'d-flex justify-content-end gap-2'}>
                                        <QButton
                                            type={'default'}
                                            onClick={() => {
                                                setOpen(false)
                                            }}
                                            content={t("common.button.cancel")}
                                        />

                                        <QButton
                                            type={'primary'}
                                            onClick={() => {
                                                formik.handleSubmit()
                                            }}
                                            content={t("common.button.submit")}
                                        />

                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                }}
            </Formik>
        </React.Fragment>
    )
}

export default BodyInvoiceSetupComponent
